import { Component, OnInit, ViewChild, enableProdMode } from '@angular/core';
import { DxDataGridComponent, DxScrollViewComponent } from 'devextreme-angular';
import { GeneralService } from '../../../services/formulacion/general.service';
import { UtilHelper } from '../../../_helpers/util';
import { environment } from '../../../../environments/environment';
import { PoaTechoService } from 'src/app/services/service.index';
declare const toastr: any;

@Component({
  selector: 'app-inicio-formulacion',
  templateUrl: './inicio-formulacion.component.html',
  styles: []
})
export class InicioFormulacionComponent implements OnInit {
  tipo_agregacion_id: number = 1;
  dataResourceAgregacion: any[];
  techos: any[];
  oTechos: any[];
  auditTraspasos: any[];
  baseUrl = environment.apiEndpoint;
  techoId: number;
  popupVisibleEstado: boolean = false;
  popupVisibleO: boolean = false;
  rol: number = 0;
  gestion: number = 0;
  popupVisible: boolean = false;
  unidad: number;

  constructor(private _gs: GeneralService, private _ts: PoaTechoService) {
    //this.tipo_agregacion_id = 1;
    let u = JSON.parse(localStorage.getItem('u'));
    this.gestion = JSON.parse(localStorage.getItem('g'));
    
    if (u != null)
    {
      this.unidad = u.unidad;
      this.rol = u.rol;
      this.tipo_agregacion_id = 1;
    }
      
    this.getTipoAgregacion();
    this.getTechoByUO();

  }

  ngOnInit() {
  }

  onToolbarPreparing(e) {
    e.toolbarOptions.items.unshift({
      location: 'before',
      template: 'acciones'
    },);
  }

  getTechoByUO() {
    
      
    this._gs.getTechoByUOByTipoAgregacion(this.unidad, this.tipo_agregacion_id).subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          
          this.techos = result.data;
        } else {
          this.techos = [];
        }
      },
      (error) => { console.log('Error', error); });
    
  }

  refreshDataGridTipo(e) {
    this.tipo_agregacion_id = e.value;
    this.getTechoByUO();
  }

  getTipoAgregacion() {
    this._ts.getTipoAgregacion().subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.dataResourceAgregacion = result.data;

        } else {
          this.dataResourceAgregacion = [];
        }
      },
      (error) => { console.log('Error', error); });
  }

  showModalEnviarRevision(id: number) {
    this.techoId = id;
    this.popupVisibleEstado = true;
  }

  enviarRevision() {
    this._gs.updateEstadoTecho({ id: this.techoId }).subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.popupVisibleEstado = false;
          toastr.success('Operación realizada exitosamente.');
          // fRnk, agregar para que se oculte el botón una vez enviado
        }
      },
      (error) => { console.log('Error', error); });
  }

  showModalObs(id: number) {
    this._gs.getObservacionesTecho(id).subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.oTechos = result.data;
        } else {
          this.oTechos = [];
        }
      });
    this.popupVisibleO = true;
  }

  showModalAuditTraspasos(data: any) {
    this.techoId = data.id;
    this.getAuditoriaTraspasos(this.techoId);
    this.popupVisible = true;
  }

  getAuditoriaTraspasos(id: number) {

    this._gs.getAuditoriaTraspasos(id).subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.auditTraspasos = result.data;
        } else {
          this.auditTraspasos = [];
        }
      },
      (error) => { console.log('Error', error); });
  }

  
}
